// TODO: Move validate massage from common.js
export default {
  '{name} is required.': '{name} is required.',

  'Please enter a number.': 'Please enter a number.',
  'Please enter a number greater than {number}.': 'Please enter a number greater than {number}.',
  '{number} or less': '{number} or less',
  'Please enter a number smaller than {number}.': 'Please enter a number smaller than {number}.',
  '{number} or more': '{number} or more',

  'Please enter a {name}.': 'Please enter a {name}.',
  '{name} must be between {min} and {max}.': '{name} must be between {min} and {max}.',
  '{name} must be within {min} to {max} characters.':
    '{name} must be within {min} to {max} characters.',

  'Please enter within {number} characters.': 'Please enter within {number} characters.',
  '{number} letters or less': '{number} letters or less',
  'Please enter at least {number} characters.': 'Please enter at least {number} characters.',
  '{number} letters or more': '{number} letters or more',

  'Please select {name}.': 'Please select {name}.',
  'Please enter an integer.': 'Please enter an integer.',
};
